import { render } from "./IconLoading.vue?vue&type=template&id=d22eeeae&scoped=true"
import script from "./IconLoading.vue?vue&type=script&lang=ts"
export * from "./IconLoading.vue?vue&type=script&lang=ts"

import "./IconLoading.vue?vue&type=style&index=0&id=d22eeeae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d22eeeae"

export default script